import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ObjectResolverBase } from '../../shared/base/object-resolver-base';
import { User } from "./user";
import { UserService } from "./user.service";


@Injectable()
export class UserResolver extends ObjectResolverBase<User> {
  constructor(service: UserService, router: Router) {
    super(service, router);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/users/shared/user-resolver.service.ts